/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidationTokenModel } from '../../models/validation-token-model';

export interface GetValidationTokens$Json$Params {
  token: string;
}

export function getValidationTokens$Json(http: HttpClient, rootUrl: string, params: GetValidationTokens$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationTokenModel>>> {
  const rb = new RequestBuilder(rootUrl, getValidationTokens$Json.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ValidationTokenModel>>;
    })
  );
}

getValidationTokens$Json.PATH = '/api/ValidationToken';
